import { httpClient } from '@/lib/http-client'
import { type PagedRequest, buildPagedParams } from '@/shared/types'

export const assessmentsApi = {
    list: (params?: PagedRequest) =>
        httpClient.get('/assessments', { params: Object.fromEntries(buildPagedParams(params)) }),
    create: (data: any) => httpClient.post('/assessments', data),
    get: (id: string) => httpClient.get(`/assessments/${id}`),
    start: (id: string) => httpClient.post(`/assessments/${id}/start`),
    update: (id: string, data: any) => httpClient.put(`/assessments/${id}`, data),
    answers: (id: string, params?: PagedRequest) => 
        httpClient.get(`/assessments/${id}/answers`, { params: params ? Object.fromEntries(buildPagedParams(params)) : { per_page: 1000 } }),
    batchAnswers: (id: string, questionIds: string[]) =>
        httpClient.post(`/assessments/${id}/answers/batch`, { question_ids: questionIds }),
    progress: (id: string) => httpClient.get(`/assessments/${id}/progress`),
    saveAnswer: (id: string, data: any, file?: File) => {
        if (file) {
            const formData = new FormData()
            formData.append('questionId', data.questionId)
            formData.append('value', data.value.toString())
            if (data.comment) {
                formData.append('comment', data.comment)
            }
            formData.append('file', file)
            return httpClient.post(`/assessments/${id}/answers`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
        } else {
            return httpClient.post(`/assessments/${id}/answers`, data)
        }
    },
    deleteAnswer: (id: string, questionId: string) =>
        httpClient.delete(`/assessments/${id}/answers/${questionId}`),
    auditTrail: (id: string) => httpClient.get(`/assessments/${id}/audit-trail`),
    serveFile: (assessment_id: string, question_id: string) =>
        httpClient.get(`/assessments/attachments/${assessment_id}/answers/${question_id}/attachment`, { responseType: 'blob' }),
    previewFile: (assessment_id: string, question_id: string) =>
        httpClient.get(`/assessments/attachments/${assessment_id}/answers/${question_id}/attachment`, {
            params: { preview: 'true' },
            responseType: 'blob'
        }),
    listAttachments: (params: { page?: number, per_page?: number, org_id?: string, assessment_id?: string, question_id?: string, search?: string }) => 
        httpClient.get('/assessments/attachments', { params }),
    delete: (id: string) => httpClient.delete(`/assessments/${id}`),
}
